import React from 'react';
import SafeIcon from '../../../common/SafeIcon';

const ManagerView = () => {
  // Mock Data for Training Matrix
  const team = [
    { name: "Sarah Jenkins", role: "Support Worker", safeguarding: true, mca: true, mh: false },
    { name: "James Cole", role: "Senior Carer", safeguarding: true, mca: true, mh: true },
    { name: "Aisha Patel", role: "Support Worker", safeguarding: false, mca: true, mh: false },
    { name: "Mark Davies", role: "Team Leader", safeguarding: true, mca: true, mh: true },
  ];

  const StatusIcon = ({ status }) => (
    status 
      ? <div className="mx-auto w-6 h-6 bg-green-100 rounded-full flex items-center justify-center"><SafeIcon name="Check" className="w-4 h-4 text-green-600" /></div>
      : <div className="mx-auto w-6 h-6 bg-red-100 rounded-full flex items-center justify-center"><SafeIcon name="X" className="w-4 h-4 text-red-600" /></div>
  );

  return (
    <div className="space-y-6">
      {/* Stats Row */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
          <p className="text-sm font-semibold text-slate-500 mb-1">Overall Compliance</p>
          <p className="text-3xl font-bold text-navy-900">78%</p>
          <div className="w-full bg-slate-100 rounded-full h-1.5 mt-4">
            <div className="bg-gold-500 h-1.5 rounded-full" style={{ width: '78%' }}></div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
          <p className="text-sm font-semibold text-slate-500 mb-1">Action Required</p>
          <p className="text-3xl font-bold text-red-600">3 Staff</p>
          <p className="text-xs text-slate-400 mt-2">Missing mandatory modules</p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center">
           <button className="w-full bg-navy-900 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-navy-800 transition-colors">
             <SafeIcon name="Download" className="w-4 h-4" /> Export Matrix (CSV)
           </button>
        </div>
      </div>

      {/* The Killer Feature: Compliance Matrix */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="p-6 border-b border-slate-200 flex justify-between items-center bg-slate-50">
          <h2 className="text-lg font-bold text-navy-900">Training Matrix</h2>
          <div className="flex gap-2">
            <span className="flex items-center gap-1 text-xs text-slate-600"><div className="w-2 h-2 rounded-full bg-green-500"></div> Compliant</span>
            <span className="flex items-center gap-1 text-xs text-slate-600"><div className="w-2 h-2 rounded-full bg-red-500"></div> Action Needed</span>
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-white border-b border-slate-200">
              <tr>
                <th className="p-4 font-semibold text-slate-600">Staff Member</th>
                <th className="p-4 font-semibold text-slate-600 text-center border-l border-slate-100">Safeguarding (L3)</th>
                <th className="p-4 font-semibold text-slate-600 text-center border-l border-slate-100">MCA & DoLS</th>
                <th className="p-4 font-semibold text-slate-600 text-center border-l border-slate-100">Mental Health Exc.</th>
                <th className="p-4 font-semibold text-slate-600 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {team.map((member, idx) => (
                <tr key={idx} className="hover:bg-slate-50 transition-colors">
                  <td className="p-4">
                    <p className="font-bold text-navy-900">{member.name}</p>
                    <p className="text-xs text-slate-500">{member.role}</p>
                  </td>
                  <td className="p-4 border-l border-slate-100"><StatusIcon status={member.safeguarding} /></td>
                  <td className="p-4 border-l border-slate-100"><StatusIcon status={member.mca} /></td>
                  <td className="p-4 border-l border-slate-100"><StatusIcon status={member.mh} /></td>
                  <td className="p-4 text-right">
                    <button className="text-navy-600 hover:text-navy-900 font-medium text-xs border border-navy-200 px-3 py-1.5 rounded">View Profile</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManagerView;